import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { AppConstants } from '../constants/app.contants';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';
import { GetAllBidsResponse, BidItem } from '../models/app.models';

@Injectable({
  providedIn: 'root'
})
export class BidService {

  constructor(private _http: HttpClient) {}

  private createApiService(): ApiService {
    const apiService = new ApiService(this._http);
    apiService.setBaseUrl(environment.API_URL);
    return apiService;
  }

  /**
   * Fetches all bids from the API
   * @param sendMock Optional parameter to send mock data (default: true)
   * @returns Promise with GetAllBidsResponse
   */
  public async getAllBids(sendMock: boolean = true): Promise<GetAllBidsResponse> {
    const apiService = this.createApiService();
    
    try {
      const req$ = apiService.get(
        AppConstants.CONTROLLERS.bids,
        AppConstants.ACTIONS.GetAllBids,
        true,
        environment.APIs_PREFIX,
        { sendMock: sendMock.toString() }
      );

      const response: any = await lastValueFrom(req$);
      return response as GetAllBidsResponse;
    } catch (error) {
      console.error('Failed to fetch bids:', error);
      throw error;
    }
  }

  /**
   * Maps API BidItem to component bid format
   * @param bidItem API bid item
   * @returns Mapped bid object for component use
   */
  public mapBidItemToComponentFormat(bidItem: BidItem): any {
    const bidId = bidItem.bidId || '';
    const normalizedBidId = bidId.toString().trim().toUpperCase();
    const isPracticeBid = normalizedBidId.startsWith('PRA-') && !normalizedBidId.startsWith('FWA-PRA-');

    const status = (bidItem.status || '').toString();
    return {
      bidId,
      vendorId: bidItem.vendorId || '',
      tenderId: bidItem.tenderId,
      vendor: bidItem.vendorName,
      submissionDeadline: new Date(bidItem.submissionDeadline),
      status: status.toLowerCase() === 'regret' ? 'Rejected' : status,
      tcCommitteeStatus: (bidItem.tcComitteeStatus ?? (bidItem as any).tCComitteeStatus ?? '').toString(),
      evaluationType: bidItem.evaluationType,
      totalScore: bidItem.totalScore,
      votingStatus: bidItem.votingStatus,
      awardDecision: bidItem.decision,
      isBidLocked: !!bidItem.isBidLocked,
      isBidDecisionFinal: !!bidItem.isBidDecisionFinal,
      sealedBidMessage: bidItem.sealedBidMessage || ''
    };
  }
}

